import {
	FormControl,
	FormLabel,
	Grid,
	GridItem,
	Heading,
	Input,
	InputGroup,
	InputLeftElement,
	InputRightElement,
	Text,
} from "@chakra-ui/react";
import React from "react";

const SubmitPropertyForm4 = (props) => {
	const { register, errors } = props;
	return (
		<>
			<Heading w="100%" textAlign={"center"} fontWeight="normal" mb="2%">
				Performance Metrics
			</Heading>
			<Grid templateColumns={"repeat(2, 1fr)"} gap={5}>
				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl mr="5%">
						<FormLabel htmlFor="closing-date" fontWeight={"normal"}>
							Closing Date
						</FormLabel>
						<Input id="closing-date" type="date" {...register("closingDate")} />
					</FormControl>
				</GridItem>

				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel htmlFor="price-per-token" fontWeight={"normal"}>
							Price Per Token
						</FormLabel>
						<InputGroup>
							<InputLeftElement pointerEvents="none" children="$" />
							<Input
								id="price-per-token"
								placeholder="Price per Token"
								type="number"
								{...register("pricePerToken", {
									required: "Price per token is required",
									min: {
										value: 1,
										message: "Minimum price per token required is $1",
									},
								})}
							/>
						</InputGroup>
						{errors.pricePerToken && (
							<Text color="red">{errors.pricePerToken.message}</Text>
						)}
					</FormControl>
				</GridItem>
			</Grid>

			<FormControl mt="2%">
				<FormLabel htmlFor="net-operating-income" fontWeight={"normal"}>
					Net Operating Income
				</FormLabel>
				<InputGroup>
					<InputLeftElement pointerEvents="none" children="$" />
					<Input
						id="net-operating-income"
						placeholder="Net Operating Income"
						{...register("netOperatingIncome", {
							min: 0,
							message: "Value cannot be negative",
						})}
					/>
				</InputGroup>
				{errors.netOperatingIncome && (
					<Text color="red">{errors.netOperatingIncome.message}</Text>
				)}
				{/* <FormHelperText>We&apos;ll never share your email.</FormHelperText> */}
			</FormControl>

			<FormControl>
				<FormLabel htmlFor="square-meter" fontWeight={"normal"} mt="2%">
					Square Meter
				</FormLabel>
				<InputGroup>
					<Input
						pr="4.5rem"
						placeholder="square meter"
						type="number"
						{...register("squareMeter", {
							min: {
								value: 1,
								message: "Square meter cannot be 0 or negative",
							},
						})}
					/>
					<InputRightElement
						pointerEvents="none"
						children={
							<span>
								m<sup>2</sup>
							</span>
						}
					/>
				</InputGroup>
				{errors.squareMeter && (
					<Text color="red">{errors.squareMeter.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Target Equity</FormLabel>
				<InputGroup>
					<InputLeftElement pointerEvents="none" children="$" />
					<Input
						type="number"
						placeholder="Target Equity"
						{...register("targetEquity", {
							min: {
								value: 1,
								message: "Target Equity's minimum value can be $1",
							},
						})}
					/>
				</InputGroup>
				{errors.targetEquity && (
					<Text color="red">{errors.targetEquity.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Target Period (years)</FormLabel>
				<Input
					placeholder="Target Period"
					{...register("targetPeriod", {
						min: {
							value: 0,
							message: "Minimum target period can be 1 year",
						},
					})}
				/>
				{errors.targetPeriod && (
					<Text color="red">{errors.targetPeriod.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Targeted Average Cash Yield</FormLabel>
				<InputGroup>
					<Input
						placeholder="Target Average Cash Yield"
						step={0.01}
						type="number"
						{...register("averageCashYield", {
							min: {
								value: 1,
								message: "Percentage ranges between 0 - 100",
							},
							max: {
								value: 100,
								message: "Percentage ranges between 0 - 100",
							},
						})}
					/>
					<InputRightElement pointerEvents="none" children="%" />
				</InputGroup>
				{errors.averageCashYield && (
					<Text color="red">{errors.averageCashYield.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Targeted Equity Multiple</FormLabel>
				<InputGroup>
					<InputLeftElement pointerEvents="none" children="$" />
					<Input
						placeholder="Target Equity Multiple"
						step={0.01}
						type="number"
						{...register("targetEquityMultiple", {
							min: 1,
							message: "Minimum value for Equity Multiple is $1",
						})}
					/>
				</InputGroup>
				{errors.targetEquityMultiple && (
					<Text color="red">{errors.targetEquityMultiple.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Targeted Investor IRR</FormLabel>
				<InputGroup>
					<Input
						placeholder="Target Investor IRR"
						step={0.01}
						{...register("targetInvestorIRR", {
							min: {
								value: 1,
								message: "Percentage ranges between 0 - 100",
							},
							max: {
								value: 100,
								message: "Percentage ranges between 0 - 100",
							},
						})}
					/>
					<InputRightElement pointerEvents="none" children="%" />
				</InputGroup>
				{errors.targetInvestorIRR && (
					<Text color="red">{errors.targetInvestorIRR.message}</Text>
				)}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Property Units</FormLabel>
				<Input
					placeholder="Property Units"
					type="number"
					{...register("units", {
						min: {
							value: 0,
							message: "Minimum property units can be 1",
						},
					})}
				/>
				{errors.units && <Text color="red">{errors.units.message}</Text>}
			</FormControl>

			<FormControl mt="2%">
				<FormLabel>Year Built</FormLabel>
				<Input placeholder="Year Built" {...register("yearBuilt")} />
			</FormControl>
		</>
	);
};

export default SubmitPropertyForm4;
